<template>
  <div id="auth">
    <div class="container auth-text flex-column">
      <h1>{{$_('auth_title')}}</h1>
      <p class="text-md c-black">
        {{$_('auth_text')}}
      </p>
    </div>
    <transition appear>
      <div id="auth-form-container">
        <div class="tab-container">
          <div class="tab" @click="signin = true, signup = false" :class="{ 'active': signin }">
            <span>{{$_('to_log_in')}}</span>
          </div>
          <div class="tab" @click="signin = false, signup = true" :class="{ 'active': signup }">
            <span>{{$_('create_account')}}</span>
          </div>
        </div>
        <div id="auth-signin" class="auth-form" v-if="signin">
          <SignIn />
        </div>
        <div id="auth-signup" class="auth-form" v-if="signup">
          <SignUp />
        </div>
      </div>
    </transition>

    <div class="container flex-column">
      <p class="text auth-text text-sm">{{$_('auth_bottom_text')}}</p>
    </div>
  </div>
</template>

<script>

import SignIn from '@/modules/authentification/components/SignIn';
import SignUp from '@/modules/authentification/components/SignUp';

export default {
  data() {
    return {
      signin: true,
      signup: false
    };
  },
  name: "authentification",
  components: {
    SignIn,
    SignUp
  },
  created() {
    // this.$store.dispatch('application/SATABAPP_RESET');
  }
};
</script>

<style scoped>
#auth {
  padding: 80px 0px;
  max-width: 639px;
  margin: auto;
}
.auth-form {
  background-color: #fff;
  padding: 60px;
}
.tab-container {
  display: flex;
}
.tab-container .tab {
  padding: 10px 20px;
}
.tab-container .tab.active {
  border-bottom: solid 2px red;
}
.tab-container .tab.active span {
  color: var(--c-black);
}
.tab-container .tab span {
  font-size: var(--fz-lg);
  color: var(--c-grey);
}
@media screen and (max-width: 800px){
  .auth-form {
    background-color: #fff;
    padding: 15px;
  }
  .tab-container .tab {
    width: 50%;
    text-align: center;
  }
  .auth-text {
    text-align: center;
    padding: 0px 20px;
  }
}
</style>